import { getApiUrl } from "../utils/get-api-url";

export const getNotices = async ({ inactive, programConfigID }) => {
  const params = new URLSearchParams({ inactive });
  const apiUrl = getApiUrl("pxprogram2");
  const fullUrl = `${apiUrl}/programs/${programConfigID}/notices?${params.toString()}`;

  const response = await fetch(fullUrl, {
    method: "GET",
    credentials: "include"
  });

  const { statusText, ok, status } = response;
  if (!ok)
    throw Object.assign(new Error(json.message || statusText), { status });

  const json = await response.json();
  return json;
};
